import { AlertMessage, MUIIcon, Spinner } from "../../../../widgets"
import { FC, useState } from "react"

import { IPaymentButtonProps } from "../IPaymentButtonProps"
import { NTTScript } from "./NTTScript"
import { PageLinkHelper } from "../../../../base/helpers"
import clsx from "clsx"
import { getButtonClass } from "../../buttons/helper"
import { toAbsoluteUrl } from "../../../../../helpers"
import { useAuth } from "../../../../../modules/auth"
import { useGetTokenMutation } from "./services/nttApi"

export const NTTButton: FC<IPaymentButtonProps> = ({
    orderNo,
    enrolmentNo,
    firstName,
    email,
    phoneNumber,
    entity,
    entityId,
    amount,
    successPage,
    failedPage,
    disabled,
    tooltip,
    style,
    size,
    className,
    icon,
    label,
    currency,
    children
}) => {
    const [isSubmitting, setIsSubmitting] = useState<boolean>(false)
    const [error, setError] = useState<string>()

    const { siteId, user } = useAuth()
    const [getToken] = useGetTokenMutation()

    const handleOnClick = () => {
        if (!siteId || !user || !successPage || !failedPage || !amount) return;
        setIsSubmitting(true)
        setError('')

        const successPageUrl = PageLinkHelper.getPageLinkUrl(siteId, successPage);
        const failedPageUrl = PageLinkHelper.getPageLinkUrl(siteId, failedPage);

        getToken({
            orderNo,
            enrolmentNo,
            name: firstName || '',
            email: email || '',
            phoneNumber: phoneNumber || '',
            entity,
            entityId,
            amount,
            successPageUrl,
            failedPageUrl,
            currency: currency || "INR"
        })
            .unwrap()
            .then(data => NTTScript.openPay(data))
            .catch(() => setError('Failed to generate payment request.'))
            .finally(() => setIsSubmitting(false))
    }

    return (
        <>
            <button
                disabled={disabled === true || isSubmitting === true || !user || !amount}
                type="button"
                title={tooltip}
                onClick={handleOnClick}
                className={clsx(getButtonClass(style, size, "btn-secondary"), className)}
            >
                <Spinner show={isSubmitting} className="me-1" />
                <img
                    alt='img'
                    className='h-15px'
                    src={toAbsoluteUrl('/media/logos/ntt-data.svg')}
                />
                {(!isSubmitting && icon) && <MUIIcon iconName={icon} className={clsx({ "me-1": !!label })} />}
                {label && <span>{label}</span>}
                {children}
            </button>
            <AlertMessage type="Error" show={!!error} message={error} />
        </>
    )
}